const denverClock = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Denver', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
});

export function getBusinessStatus(now = new Date()) {
  const parts = Object.fromEntries(denverClock.formatToParts(now).map(({ type, value }) => [type, value]));
  const minutes = Number(parts.hour) * 60 + Number(parts.minute);
  const close = parts.weekday === 'Sat' ? 14 * 60 : 18 * 60;
  const isOpen = parts.weekday !== 'Sun' && minutes >= 8 * 60 && minutes < close;
  return { isOpen, label: isOpen ? 'Open now' : 'Closed', closesAt: parts.weekday === 'Sat' ? '2 PM' : '6 PM' };
}